import React, { useState } from "react";
import styles from "./ReplyModal.module.css";
import axios from "axios";

const ReplyModal = ({ isOpen, onClose, reviewId, onReplySuccess }) => {
  const [author, setAuthor] = useState("");
  const [email, setEmail] = useState("");
  const [text, setText] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`/api/reviews/${reviewId}/reply`, {
        author: author || "Анонім",
        email,
        text,
      });
      setAuthor("");
      setEmail("");
      setText("");
      onReplySuccess();
      onClose();
    } catch (err) {
      console.error("Помилка при надсиланні відповіді:", err);
    }
  };

  return (
    <div className={styles.replyModalOverlay}>
      <div className={styles.replyModalContent}>
        <h3>Відповідь на відгук</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Ваше ім'я (необов'язково)"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
            className={styles.replyModalInput}
          />
          <input
            type="email"
            placeholder="Ваш email (необов'язково)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={styles.replyModalInput}
          />
          <textarea
            placeholder="Ваша відповідь..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            className={styles.replyModalTextarea}
          ></textarea>
          <div className={styles.replyModalButtons}>
            <button type="submit" className={styles.replyModalSubmit}>
              Надіслати відповідь
            </button>
            <button
              type="button"
              onClick={onClose}
              className={styles.replyModalCancel}
            >
              Скасувати
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReplyModal;
